// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"content-block_wrapper__Mcr36","theme-good-green":"content-block_theme-good-green__Q9Zdp","theme-good-blue":"content-block_theme-good-blue__jq9kk"};